import { render, staticRenderFns } from "./ContactPreferencesPage.vue?vue&type=template&id=e39f9016&scoped=true&"
import script from "./ContactPreferencesPage.vue?vue&type=script&lang=js&"
export * from "./ContactPreferencesPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactPreferencesPage.vue?vue&type=style&index=0&id=e39f9016&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39f9016",
  null
  
)

export default component.exports